import HomeIcon from "../../../assets/icons/home.png";
import Expertise from "../../../assets/icons/expertise.png";
import Projects from "../../../assets/icons/projects.png";
// import Stats from "../../../assets/icons/stats.png";
// import Contributions from "../../../assets/icons/contributions.png";
import Contact from "../../../assets/icons/contact.png";
export const NavData = [
  {
    id: 1,
    lebal: "Home",
    icon: HomeIcon,
    path: "#HOME",
  },

  {
    id: 2,
    lebal: "Expertise",
    icon: Expertise,
    path: "#EXPERTISE",
  },
  {
    id: 3,
    lebal: "Projects",
    icon: Projects,
    path: "#PROJECTS",
  },

  {
    id: 4,
    lebal: "Contact",
    icon: Contact,
    path: "#CONTACT",
  },
];
